exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select-dropdown__item.hover{background-color:#e6e9ee}.testimonial-group>.row{overflow-x:auto;white-space:nowrap;overflow-y:hidden}.testimonial-group>.row>.col-sm-3{display:inline-block;float:none}.col-sm-3{height:70px;margin-right:.5%;color:#fff;font-size:18px;padding-bottom:20px;padding-top:18px;font-weight:700}.card-block{min-height:220px}.ex1{overflow-x:scroll}.cat_c{width:100px;margin:1%;padding:3px;font-weight:700;min-height:90px}.cat_c,.cat_c p{color:#fff}.c-width{width:80px!important;padding:0!important;margin-right:0!important}.el-select-dropdown{max-width:80%!important;margin-right:1%!important}.el-input-group__append{padding:0 10px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-218e4691","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/pos/index.vue
// module id = o4mq
// module chunks = 0